import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class Header extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._lastScrollY = 0
    this._currentScrollY = window.scrollY
    this._currentDirection = 'down'
    this._header = document.querySelector(this._options.header)
    this._headerHeight = this._header.getBoundingClientRect().height
    this._cartTrigger = this._elem.querySelector('.cart-trigger')
  }

  mount () {
    //this._doScrollCalculations()
    window.addEventListener('scroll', e => {
      this._doScrollCalculations()
    }, { passive: true })

    var cart = new window.theme.CartDrawer
    cart.init()

    this._cartTrigger.addEventListener('click', e => {
      cart.open()
    })

    this._header.classList.add('header--rendered')
  }

  _doScrollCalculations () {
    this._currentScrollY = window.scrollY
    this._currentDirection = this._currentScrollY > this._lastScrollY ? 'down' : 'up'
    this._lastScrollY = window.scrollY

    if (this._options.shrinkOffset) {
      if (this._currentScrollY >= this._options.shrinkOffset) {
        this._header.classList.add('shrunk')
        document.dispatchEvent(new Event('ffc--header-shrunk'))
      } else {
        this._header.classList.remove('shrunk')
        document.dispatchEvent(new Event('ffc--header-unshrunk'))
      }
    }
  }
}